import React, { useEffect } from "react";
import closeIcon from "../../assets/images/close.png";
export default function Modal({ isOpen, onClose, content }) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    // Attach the event listener when the modal is open
    if (isOpen) {
      document.addEventListener("keydown", handleKeyDown);
    }

    // Cleanup the event listener when the modal is closed or unmounted
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null; // Check if the modal should be displayed

  return content?.length > 0 ? ( // Check if content exists and is non-empty
    <div>
      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white rounded-lg shadow-lg w-full max-w-screen-md">
          <div className="flex justify-between items-center border-b border-gray-200 p-4 h-8">
            <h3></h3>
            <button
              onClick={onClose}
              className="text-red-500 hover:text-gray-800 text-xl"
              aria-label="Close"
            >
              <img className="float-right" src={closeIcon} alt="img" />
            </button>
          </div>

          {/* Modal Body */}

          <div className="p-4">
            <div className="p-4 bg-white shadow rounded-md relative">
              {/* Header Section */}
              <div className="flex items-center justify-between border-b pb-4 mb-4">
                <div className="flex items-center gap-4">
                  <div className="bg-gray-200 rounded-full h-12 w-12 flex items-center justify-center">
                    <span className="text-xl font-semibold text-gray-700">
                      JC
                    </span>
                  </div>
                  <div>
                    <h2 className="text-xl font-semibold text-gray-800">
                      {content[0]?.LICENSE_NO?.[0] || "--"}
                    </h2>
                    <span className="text-sm text-green-500">
                      {content[0]?.ORDER_NUM?.[0] || "--"}
                    </span>
                  </div>
                </div>
                <div>
                  Chassis Number:
                  <p className="text-sm text-green-500">
                    {content[0]?.ASSET_NUM?.[0] || "--"}
                  </p>
                </div>
              </div>

              {/* Details Section */}
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm text-gray-700">
                {[
                  {
                    label: "JC Created Date",
                    value: content[0]?.CREATED_DATE?.[0],
                  },
                  {
                    label: "JC Open Buckets",
                    value: content[0]?.JC_OPEN_BUCKETS?.[0],
                  },
                  { label: "SR Number", value: content[0]?.SR_NUMBER?.[0] },
                  {
                    label: "Service Type",
                    value: content[0]?.SERVICE_TYPE?.[0],
                  },
                  { label: "Workshop Name", value: content[0]?.DIVISION?.[0] },
                  {
                    label: "Service Delay Reason",
                    value: content[0]?.SRV_DELAY_RSN?.[0],
                  },
                ].map((item, index) => (
                  <div key={index}>
                    <p className="font-medium">{item.label}</p>
                    <p>{item.value || "--"}</p>
                  </div>
                ))}
              </div>

              {/* Timeline Section */}
              <div className="mt-6">
                <h3 className="text-gray-700 text-lg font-medium mb-4">
                  Workshop Timelines
                </h3>
                <div className="flex items-center justify-between">
                  {[
                    {
                      step: 1,
                      label: "Fenced In",
                      value: content[0]?.FENCE_IN_DATETIME,
                    },
                    {
                      step: 2,
                      label: "Gate In",
                      value: content[0]?.GATEIN_DATETIME,
                    },
                    { step: 3, label: "SR", value: content[0]?.SR_NUMBER },
                    { step: 4, label: "JC", value: content[0]?.CREATED_DATE },
                    {
                      step: 5,
                      label: "Floor In",
                      value: content[0]?.FLOOR_IN_TIME,
                    },
                    {
                      step: 6,
                      label: "Floor Out",
                      value: content[0]?.FLOOR_OUT_TIME,
                    },
                    {
                      step: 7,
                      label: "Road Test",
                      value: content[0]?.ROAD_TEST,
                    },
                  ].map((item, index) => (
                    <div key={index} className="flex items-center gap-2">
                      <div className="text-center">
                        {item.value && item.value.length > 0 ? (
                          <div
                            className="h-8 w-8 flex items-center justify-center rounded-full border bg-blue-500 text-white text-sm font-medium"
                            title={`${item.label}: ${item.value[0]}`}
                          >
                            {item.step}
                          </div>
                        ) : (
                          <div className="h-8 w-8 flex items-center justify-center rounded-full border bg-gray-200 text-sm font-medium">
                            {item.step}
                          </div>
                        )}
                        <p className="text-xs text-gray-600 mt-1">
                          {item.label}
                        </p>
                      </div>
                      {index < 6 && (
                        <div className="h-[2px] w-6 bg-gray-300"></div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
}
